import React from "react"

import FolderIcon from "assets/folder-outline.svg"

function PublishingDetails(props) {
  const {
    publishDate,
    category
  } = props

  return (
    <>
      <p className="p-3 text-sm">
        {publishDate ? (
          <span className="">
            {publishDate}&nbsp;&middot;&nbsp;
          </span>
        ) : null}
        <span className="h-4 w-4 inline-block mr-1 align-text-bottom">
          <FolderIcon />
        </span>
        <span>
          {category} 
        </span>
      </p>
    </>
  )
}

export default PublishingDetails
